import { render, staticRenderFns } from "./SensitiveWordManagement.vue?vue&type=template&id=04babd28&scoped=true"
import script from "./SensitiveWordManagement.vue?vue&type=script&lang=js"
export * from "./SensitiveWordManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04babd28",
  null
  
)

export default component.exports